import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import getCardClasses from '../util/GetCardClasses';

var ResourcePrice = function ResourcePrice(_ref) {
  var formattedInitialPrice = _ref.formattedPrice,
      discountedPrice = _ref.discountedPrice,
      price = _ref.price,
      hasDiscount = _ref.hasDiscount,
      cardSize = _ref.cardSize,
      discountBestPercentage = _ref.discountBestPercentage,
      listClasses = _ref.listClasses,
      bundleOriginalPrice = _ref.bundleOriginalPrice,
      isBundleSale = _ref.isBundleSale;
  var oldPriceClasses = classNames(getCardClasses('resource-card__media-footer__price--old', cardSize));
  var currencyClasses = classNames(getCardClasses('resource-card__media-footer__currency', cardSize));
  var priceClasses = classNames(getCardClasses('resource-card__media-footer__price', cardSize));

  if (cardSize === 'xxs') {
    oldPriceClasses = 'resource-card__media-heading-price-old';
    currencyClasses = 'resource-card__media-heading-currency';
    priceClasses = 'resource-card__media-heading-amount';
  }

  var formattedFinalPrice = formattedInitialPrice;
  var finalPrice = null;
  var currencySymbol = null;
  var oldPriceComponent = null;

  if (discountedPrice && hasDiscount) {
    oldPriceComponent = /*#__PURE__*/React.createElement("span", {
      className: oldPriceClasses
    }, formattedInitialPrice);
    formattedFinalPrice = discountedPrice;
  }

  if (!formattedInitialPrice || price === 0) finalPrice = 'FREE';

  if (formattedFinalPrice) {
    currencySymbol = formattedFinalPrice.replace(/[0-9.,]/g, '');
    finalPrice = formattedFinalPrice.replace(currencySymbol, '');
  }

  if (discountBestPercentage) {
    discountBestPercentage = Math.round(parseFloat(discountBestPercentage) * 100);
  }

  var discountComponent = /*#__PURE__*/React.createElement("span", {
    className: "resource-card__discount"
  }, discountBestPercentage, "% off");
  var bundleSaveComponent = hasDiscount ? /*#__PURE__*/React.createElement("span", {
    className: "resource-card__discount"
  }, discountBestPercentage, "% off") : /*#__PURE__*/React.createElement("span", {
    className: "resource-card__discount"
  }, "Save ", Math.round((1 - finalPrice / bundleOriginalPrice) * 100), "%");
  var currencyComponent = currencySymbol ? /*#__PURE__*/React.createElement("span", {
    className: currencyClasses
  }, currencySymbol) : null;
  var priceComponent = /*#__PURE__*/React.createElement("span", {
    className: priceClasses
  }, finalPrice);

  if (isBundleSale && bundleOriginalPrice) {
    return /*#__PURE__*/React.createElement("div", {
      className: listClasses
    }, currencyComponent, priceComponent, bundleSaveComponent);
  }

  if (listClasses) {
    return /*#__PURE__*/React.createElement("div", {
      className: listClasses
    }, currencyComponent, priceComponent, hasDiscount ? discountComponent : oldPriceComponent);
  }

  return /*#__PURE__*/React.createElement("span", {
    className: cardSize === 'xxs' ? 'resource-card__media-heading-price' : ''
  }, currencyComponent, priceComponent, hasDiscount ? discountComponent : oldPriceComponent);
};

ResourcePrice.displayName = "ResourcePrice";
export default ResourcePrice;
ResourcePrice.propTypes = {
  formattedPrice: PropTypes.number,
  discountedPrice: PropTypes.number,
  price: PropTypes.number,
  hasDiscount: PropTypes.bool,
  cardSize: PropTypes.string,
  discountBestPercentage: PropTypes.number,
  listClasses: PropTypes.array,
  bundleOriginalPrice: PropTypes.number,
  isBundleSale: PropTypes.bool
};